import React from "react"

const FinancialInformation = () => {
    return <div>FinancialInfomation</div>
}

export default FinancialInformation
